import React, { useState } from "react";
import { BsArrowLeftSquareFill, BsArrowRightSquareFill } from "react-icons/bs";
import oath1 from '../assets/oath-1.jpg'
import Thanks1 from '../assets/thanks1.jpg'
import LorethmaiFeast from '../assets/loretMaiFeast.jpg'
import announce1 from '../assets/announce1.png'
import announce2 from '../assets/announce2.png'
import announce3 from '../assets/announce3.jpg'

const sliderData = [
  {
    url: announce1,
  },
  {
    url: announce2,
  },
  {
    url: announce3,
  },
];

const Carousel = () => {
  let [slide, setSlide] = useState(0);
  const length = sliderData.length;

  const prevSlide = () => {
    setSlide(slide === length - 1 ? 0 : slide + 1);
  };

  const nextSlide = () => {
    setSlide(slide === 0 ? length - 1 : slide - 1);
  };

  return (
    <>
      {" "}
      <h2 className="max-w-[1240px] mx-auto px-4 py-16 ">Announcements</h2>
      <div className="max-w-[1240px] mx-auto px-4 py-16 relative flex justify-center items-center bg-slate-100">
        <BsArrowLeftSquareFill
          onClick={prevSlide}
          className="absolute  top-[50%] text-3xl text-white cursor-pointer left-8 bg-slate-900 rounded-md"
        />
        <BsArrowRightSquareFill
          onClick={nextSlide}
          className="absolute top-[50%] text-3xl text-white cursor-pointer right-8 bg-slate-900 rounded-md"
        />
        {sliderData.map((item, index) => (
          <div className={index === slide ? "opacity-100" : "opacity-0"}>
            {index === slide && (
              <img className="w-full rounded-md " src={item.url} alt="" />
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default Carousel;
